import { useNavigate } from 'react-router-dom';
import PackagesPage from '../../PackagesPage';
import { useLegacyAppSession } from '../../contexts/LegacyAppSessionContext';

export default function PackagesContainer() {
  const navigate = useNavigate();
  const { org, currentUser } = useLegacyAppSession();

  return (
    <PackagesPage
      organizationId={org?.id ?? null}
      onAdd={() => navigate('/packages/new')}
      onStage={() => navigate('/packages/stage')}
      onImport={() => navigate('/packages/import')}
      onEdit={(pkg) => navigate(`/packages/${pkg.id}/edit`, { state: { pkg } })}
      onEditStaged={(pkg) => navigate('/packages/staged/edit', { state: { pkg, pkgLabel: pkg.packageLabel } })}
      onPrint={(pkg) => navigate('/prints/new', { state: { pkg } })}
      onPrintStaged={(pkg) => navigate('/prints/staged/new', { state: { pkg } })}
      currentUser={currentUser}
    />
  );
}
